import { UserInfo } from "./user.model";

export enum TestLoginOptions {
    Doctor = "doctor",
    Patient = "patient"
}

// Results
export interface LoginResult {
    expiresIn: number;
    jwtToken: string;
    synlabId: string | null;
    userInfo: UserInfo;
    archiveCpr: string;
    schemaAccessResult?: boolean | null;
    schemaId?: number | null;
}

// Requests
export interface LoginRequest {
    code: string;
    redirectUri: string;
    schemaAccessKey?: string | null;
}

export interface TestLoginRequest {
    user: string,
    password: string,
    initials?: string
}